import $ from 'cash-dom';

let instance = null;

class MidChartBanner {
	constructor() {
		if (!instance) {
			this._$midChartBanner = $('.mid-chart-banner-container.move-on-filter');

			instance = this;
		}

		return instance;
	}

	static getInstance() {
		if (!MidChartBanner._instance) {
			MidChartBanner._instance = new MidChartBanner();
		}

		return MidChartBanner._instance;
	}

	init() {
		if (!this._$midChartBanner.length) {
			return;
		}

		$(document).on('filters-change', (e, {vendorOrderData, $vendorsList}) => {
			this._moveBannerIfNeed($vendorsList);
		});
	}

	_moveBannerIfNeed($vendorsList) {
		const $visibleVendors = $vendorsList.not('.hidden');
		const visibleVendorsLength = $visibleVendors.length;

		if (!visibleVendorsLength) {
			this._$midChartBanner.hide();
			return;
		}

		let hideBanner = true;
		$visibleVendors.each((i, element) => {
			const $element = $(element);
			if ($element.data('vendor-slug') === this._$midChartBanner.data('vendor-slug')) {
				hideBanner = false;
				return false;
			}
		});

		if (hideBanner) {
			this._$midChartBanner.hide();
			return;
		}

		const isBrandbid = this._$midChartBanner.hasClass('brandbid');

		if (isBrandbid) {
			this._$midChartBanner.css('display', 'grid');
		} else {
			let index = visibleVendorsLength < 2 ? 0 : 1;
			const $vendorBeforeMidChartBanner = $($visibleVendors[index]);
			$vendorBeforeMidChartBanner.after(this._$midChartBanner.css('display', 'flex'));
		}
	}
}

export default MidChartBanner;
